(() => {
  const FREE_SHIPPING = 100000;
  const money = cents => new Intl.NumberFormat('ar-EG', { maximumFractionDigits: 0 }).format(Math.ceil(cents / 100));

  async function refreshShipping() {
    const box = document.querySelector('[data-raheeq-shipping]');
    if (!box) return;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      const total = Number(cart.total_price || 0);
      if (!total) { box.hidden = true; return; }
      box.hidden = false;
      const remaining = Math.max(FREE_SHIPPING - total, 0);
      box.querySelector('[data-raheeq-shipping-copy]').textContent =
        remaining === 0 ? 'مبروك! حصلت على الشحن المجاني 🎉' : `باقي لك ${money(remaining)} جنيه وتحصل على الشحن المجاني`;
      box.querySelector('[data-raheeq-shipping-progress]').style.width =
        `${Math.min((total / FREE_SHIPPING) * 100, 100)}%`;
    } catch (_) {}
  }

  document.addEventListener('DOMContentLoaded', () => {
    refreshShipping();
    document.querySelector('[data-raheeq-order]')?.addEventListener('click', event => {
      const card = document.querySelector('product-card');
      if (!card) return;
      event.preventDefault();
      card.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  document.addEventListener('click', event => {
    if (event.target.closest('[name="add"], [data-quantity-selector], cart-remove-button')) {
      window.setTimeout(refreshShipping, 900);
    }
  });
  document.addEventListener('change', event => {
    if (event.target.closest('cart-items, cart-drawer, quantity-selector')) window.setTimeout(refreshShipping, 500);
  });
  document.addEventListener('cart:update', refreshShipping);
  document.addEventListener('cart:refresh', refreshShipping);
})();